import React, { useContext, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Slide,
  IconButton,
  Typography,
  Stack,
  Divider,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { AppContext, serverUrl } from "../utils";
import axios from "axios";

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const StyledModal = withStyles(() => ({
  root: {
    "& .MuiDialog-root": {
      zIndex: "1301 !important",
    },
    "&.MuiDialog-container": {
      overflowY: "hidden !important",
    },
    "& .MuiDialog-paperScrollPaper": {
      backgroundColor: "#ffff",
      height: "auto",
      width: "600px",
      boxShadow: "#ffffff 0px 0px 8px 1px",
      borderRadius: "10px",
    },
    "& .dialoge__content__section": {
      background: "#292929!important",
      borderRadius: "10px",
      border: "1px solid transparent",
    },
    "& .MuiDialogContent-root": {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
  },
}))(Dialog);

export const btnBoxStyle = {
  display: "flex",
  justifyContent: "center",
  mt: 0.5,
};

const headingStyle = {
  fontFamily: "Saira Semi Condensed",
  fontWeight: 700,
  letterSpacing: "1px",
  fontSize: { xs: "22px", sm: "28px" },
  lineHeight: "36px",
  textAlign: "center",
  color: "#ffffff",
  textTransform: "uppercase",
};

const FlexBox = ({ value1, value2 }) => {
  return (
    <Stack
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      mt={1}
    >
      <Typography
        variant="body1"
        sx={{
          fontFamily: "Montserrat",
          fontWeight: { xs: "400", sm: "400" },
          fontSize: { xs: "10px", sm: "14px" },
          lineHeight: "36px",
          textTransform: "uppercase",
          color: "#ffffff",
        }}
      >
        {value1}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontFamily: "Montserrat",
          fontWeight: { xs: "400", sm: "400" },
          fontSize: { xs: "10px", sm: "14px" },
          lineHeight: "36px",
          textTransform: "uppercase",
          color: "#ffffff",
        }}
      >
        {value2} points
      </Typography>
    </Stack>
  );
};

function PointsCalculator({ open, setOpen }) {
  const { tweetHashTagsData, userDatabaseId, setTweetHashTagsData } =
    useContext(AppContext);
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (userDatabaseId) {
      (async () => {
        try {
          const { data } = await axios.get(
            `${serverUrl}/tweet_hash_tags/${userDatabaseId}`
          );
          setTweetHashTagsData({
            orignalPost: data?.orignalPost,
            totalViews: data?.totalViews,
            comments: data?.comments,
            likes: data?.likes,
            retweet: data?.retweet,
            quote: data?.quote,
            postPoints: data?.postPoints,
            viewsPoints: data?.viewsPoints,
            commentsPoints: data?.commentsPoints,
            likesPoints: data?.likesPoints,
            retweetPoints: data?.retweetPoints,
            quotePoints: data?.quotePoints,
            claimPoints: data?.claimPoints,
          });
        } catch (e) {
          console.log(e);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDatabaseId]);

  return (
    <>
      <StyledModal
        open={open}
        keepMounted
        TransitionComponent={Transition}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className="dialoge__content__section">
          <Box borderRadius="100px" position="relative">
            <Box
              sx={{
                position: "relative",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{ mr: -2, position: "absolute", right: 0, top: -1 }}
              >
                <CloseIcon
                  sx={{
                    color: "#ffffff",
                  }}
                />
              </IconButton>
              <Typography variant="h3" sx={headingStyle}>
                Calculate Points
              </Typography>
            </Box>
            <Box mt={3}>
              <FlexBox
                value1={`${tweetHashTagsData?.orignalPost} Posts`}
                value2={tweetHashTagsData?.postPoints}
              />
              <Divider
                sx={{
                  backgroundColor: "#939393",
                }}
              />
              <FlexBox
                value1={`${tweetHashTagsData?.totalViews} View`}
                value2={tweetHashTagsData?.viewsPoints}
              />
              <Divider
                sx={{
                  backgroundColor: "#939393",
                }}
              />
              <FlexBox
                value1={`${tweetHashTagsData?.likes} LIKE`}
                value2={tweetHashTagsData?.likesPoints}
              />
              <Divider
                sx={{
                  backgroundColor: "#939393",
                }}
              />
              <FlexBox
                value1={`${tweetHashTagsData?.comments} COMMENT`}
                value2={tweetHashTagsData?.commentsPoints}
              />
              <Divider
                sx={{
                  backgroundColor: "#939393",
                }}
              />
              <FlexBox
                value1={`${tweetHashTagsData?.retweet} RETWEET`}
                value2={tweetHashTagsData?.retweetPoints}
              />
              <Divider
                sx={{
                  backgroundColor: "#939393",
                }}
              />
              <FlexBox
                value1={`${tweetHashTagsData?.quote} QUOTE RETWEET`}
                value2={tweetHashTagsData?.quotePoints}
              />
              <Divider
                sx={{
                  backgroundColor: "#939393",
                }}
              />
              <FlexBox
                value1={`Total earn Points`}
                value2={
                  +tweetHashTagsData?.postPoints +
                  +tweetHashTagsData?.viewsPoints +
                  +tweetHashTagsData?.commentsPoints +
                  +tweetHashTagsData?.likesPoints +
                  +tweetHashTagsData?.retweetPoints +
                  +tweetHashTagsData?.quotePoints
                }
              />
            </Box>
          </Box>
        </DialogContent>
      </StyledModal>
    </>
  );
}

export default PointsCalculator;
